import classNames from "classnames";
import React from "react";

import "./style.less";

type Props = React.HTMLProps<HTMLDivElement> & {
  aspectRatio?: string | number;
  className?: string;
  containerClassName?: string;
  onClick?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;

  children: any;
};

const ResponsiveContainer = ({ aspectRatio, containerClassName, className, ...props }: Props) => (
  <div
    {...props}
    className={classNames("aspect_ratio_container", containerClassName)}
    style={{
      height: "auto",
      aspectRatio: aspectRatio,
      ...(props.style ?? {})
    }}
    onClick={props.onClick}
  >
    <div className={classNames("aspect_ratio_content", className, { auto: aspectRatio === "auto" })}>
      {props.children}
    </div>
  </div>
);

export default ResponsiveContainer;
